import axios from "axios";
const apiUrl = process.env.REACT_APP_JAVA_URL;
const token = `56b6e81f-0e8b-4516-90c2-94f6f6b064e6`;
export async function getVisitIds(id) {
  let url = apiUrl + "v1/netram/visit-info/" + id;
  try {
    let response = await axios.get(url, {
      headers: {
        "x-api-key": `${token}`,
      },
    });
    if (response.data.status === "Success") {
      return response.data.result;
    } else if (response.data.status === "Failed") {
      return null;
    }
  } catch (error) {
    console.log("failed fetch error", error);
    return null;
  }
}
